/**
 * Must be imported first - ensures process is defined for dependencies that expect Node.js env.
 * Fixes "process is not defined" in browser.
 */
if (typeof window !== 'undefined' && typeof window.process === 'undefined') {
  window.process = { env: {} };
}
